import React, { useEffect, useRef, useState } from "react";
import { debounce } from "../utils/debounce";
import MeetingAttendeeList from "./MeetingAttendeeList";

const MEETING_TABS = {
    guests: "GUESTS",
    chat: "CHAT",
};

const SideTabs = ({ 
  sidebarCollapsed, 
  attendees , 
  attendeesTabLabel, 
  chatTabLabel,
  showAttendeesTab = true,   
  ShowChatTab= true}) => { 
    const sidebarRef = useRef();
    const [activeTabId, setActiveTabId] = useState(MEETING_TABS.guests);

    useEffect(() => {
        const handleResize = debounce(() => {
          const { current: sidebarEl } = sidebarRef;
    
          if (sidebarEl) {
            sidebarEl.style.width = sidebarEl.parentNode.offsetWidth + "px";
          }
        }, 350);
    
        window.addEventListener("resize", handleResize);
        handleResize();
    
        return () => window.removeEventListener("resize", handleResize);
      }, [sidebarCollapsed]);
      

    return (
        <> 
        <div
              ref={sidebarRef}
              className="context-sidebar col-sm-12 col-md-4 col-xl-3 px-0 vh-100 border-left fixed-md"
            >
              <ul
                className="nav nav-tabs context-sidebar-tabs nav-fill px-3 pt-2"
                id="myTab"
                role="tablist"
              >
                { showAttendeesTab &&
                <li className="nav-item" role="presentation">
                  <a
                    className={`nav-link ${
                      activeTabId === MEETING_TABS.guests ? "active" : null
                    }`}
                    onClick={() => setActiveTabId(MEETING_TABS.guests)}
                    id="guests-tab"
                    data-toggle="tab"
                    href="#guests"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    {attendeesTabLabel}
                  </a>
                </li>
                }

                {ShowChatTab && 
                <li className="nav-item" role="presentation">
                  <a
                    className={`nav-link ${
                      activeTabId === MEETING_TABS.chat ? "active" : null
                    }`}
                    onClick={() => setActiveTabId(MEETING_TABS.chat)}
                    id="chat-tab"
                    data-toggle="tab"
                    href="#chat"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                  >
                     {chatTabLabel}
                    <span className="badge badge-info ml-2 notify-badge "></span>
                    <span className="sr-only">new messages</span>
                  </a>
                </li>
                }
              </ul>

              <div className="tab-content context-sidebar-content overflow-auto">
                <div
                  className={`tab-pane ${
                    activeTabId === MEETING_TABS.guests ? "active" : null
                  }`}
                  id="tab-content-guests"
                  role="tabpanel"
                  aria-labelledby="tab-guests"
                >                  
                  <MeetingAttendeeList guests={attendees} />
                </div>

                <div
                  className={`tab-pane ${
                    activeTabId === MEETING_TABS.chat ? "active" : null
                  }`}
                  id="tab-content-guests"
                  role="tabpanel"
                  aria-labelledby="tab-guests"
                >
                  <div id="chat-panel"></div>
                </div>
              </div>
            </div>
        </>
    );
};
      
export default SideTabs;